import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpService } from './http.service';

@Injectable()
export class ResearchPortalBdHttp {
  constructor(protected httpService: HttpService) { }
  getSectorQuarterDates = async () => this.httpService.get(`/sector-data/quarter-dates`);
  getSectorData = async (quarterDate) => this.httpService.get(`/sector-data?quarterDate=${quarterDate}`);
  getSectorValuationMetricsData = async (quarterDate) =>
    this.httpService.get(`/sector-data/sector-valuation-metrics?quarterDate=${quarterDate}`);
  getCompanies = async () => this.httpService.get(`/company-summary/master-data/companies`);
  getRSIData = async (toDate, fromDate, instrumentCode) =>
    this.httpService.get(
      `/company-summary/historical-share-price/rsi?fromDate=${fromDate}&toDate=${toDate}&instrumentCode=${instrumentCode}`
    );
  getTickerData = async (instrumentCode) => this.httpService.get(`/company-summary/latest-ticker-data?instrumentCode=${instrumentCode}`);
  getHistoricalDataCount = async (fromDate, toDate, instrumentCode) =>
    this.httpService.get(
      `/company-summary/historical-share-price/count?fromDate=${fromDate}&toDate=${toDate}&instrumentCode=${instrumentCode}`
    );
  getHistoricalData = async (fromDate, toDate, instrumentCode) =>
    this.httpService.get(`/company-summary/historical-share-price?fromDate=${fromDate}&toDate=${toDate}&instrumentCode=${instrumentCode}`);

  getVWPMetric = async (instrumentCode, duration, base) =>
    this.httpService.get(`/company-summary/vwp-metric?instrumentCode=${instrumentCode}&duration=${duration}&base=${base}`);
  getIndexValurMatrix = async (index, duration, base) =>
    this.httpService.get(`/company-summary/index-value-metric?index=${index}&duration=${duration}&base=${base}`);
  getCompanySummary = async (instrumentCode) => this.httpService.get(`/company-summary/company-data?instrumentCode=${instrumentCode}`);
  getMarketInsights = async () => this.httpService.get(`/market-data/market-insights`);
}
@Injectable()
export class ResearchPortalBdService {
  emitChange$: Subject<any> = new BehaviorSubject<any>(null);

  emit(value: any) {
    this.emitChange$.next(value);
  }

  get emitChange(): BehaviorSubject<any> {
    return this.emitChange$ as BehaviorSubject<any>;
  }
  constructor(protected http: ResearchPortalBdHttp) { }
  getSectorQuarterDates = async () => await this.http.getSectorQuarterDates();
  getSectorData = async (quarterDate) => await this.http.getSectorData(quarterDate);
  getSectorValuationMetricsData = async (quarterDate) => await this.http.getSectorValuationMetricsData(quarterDate);
  getCompanies = async () => await this.http.getCompanies();
  getRSIData = async (toDate, fromDate, instrumentCode) => await this.http.getRSIData(toDate, fromDate, instrumentCode);
  getTickerData = async (instrumentCode) => await this.http.getTickerData(instrumentCode);
  getHistoricalDataCount = async (fromDate, toDate, instrumentCode) =>
    await this.http.getHistoricalDataCount(fromDate, toDate, instrumentCode);
  getHistoricalData = async (fromDate, toDate, instrumentCode) => await this.http.getHistoricalData(fromDate, toDate, instrumentCode);
  getVWPMetric = async (instrumentCode, duration, base) => this.http.getVWPMetric(instrumentCode, duration, base);
  getIndexValurMatrix = async (index, duration, base) => this.http.getIndexValurMatrix(index, duration, base);
  getCompanySummary = async (instrumentCode) => this.http.getCompanySummary(instrumentCode);
  getMarketInsights = async () => this.http.getMarketInsights();
}
